import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex relative flex-col min-h-screen-inner h-full w-full max-w-md" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full flex-grow flex items-stretch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timer = _resolveComponent("timer")
  const _component_questions_renderer = _resolveComponent("questions-renderer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_timer, {
      percentile: _ctx.percentile,
      display: _ctx.display,
      points: _ctx.challengeData.experience,
      "current-lives": _ctx.currentLives
    }, null, 8, ["percentile", "display", "points", "current-lives"]),
    (_ctx.newQuestion.question)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_questions_renderer, {
            type: _ctx.newQuestion.type,
            question: _ctx.newQuestion.question,
            "on-select": _ctx.onSelectOption,
            "show-results": _ctx.showResults
          }, null, 8, ["type", "question", "on-select", "show-results"])
        ]))
      : _createCommentVNode("", true)
  ]))
}